// PricelistRowTable.js
import React from "react";
import { Box } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PricelistRow from "./PricelistRow";
import { FormattedMessage } from "react-intl";

const headerStyle = {
  display: "grid",
  gridTemplateColumns: "28px 1.2fr 0.4fr 0.6fr 0.6fr 1.5fr auto", // adjusted amount column
  position: "sticky",
  top: 0,
  background: "#fff",  
  padding: "8px 0",
  zIndex: 10,
  alignItems: "center",  
};

const cellStyle = {
  padding: "0 8px",
  display: "flex",
  alignItems: "center",
};

const PricelistRowTable = ({ rows, onAddRow, onDeleteRow, onChangeRow, onMoveRow, companyId }) => {
  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    onMoveRow({ fromIndex: source.index, toIndex: destination.index });
  };

  return (
    <Box>
      <Box sx={headerStyle}>
        <Box sx={cellStyle} />
        <Box sx={cellStyle}><FormattedMessage id="admin.pricelists.table.artNo" /></Box>
        <Box sx={cellStyle}><FormattedMessage id="admin.pricelists.table.amount" /></Box>
        <Box sx={cellStyle}><FormattedMessage id="admin.pricelists.table.price" /></Box>
        <Box sx={cellStyle}><FormattedMessage id="admin.pricelists.table.productionCost" /></Box>
        <Box sx={cellStyle}><FormattedMessage id="admin.pricelists.table.description" /></Box>
        <Box sx={cellStyle} />
      </Box>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="pricelistRows">
          {(provided) => (
            <Box ref={provided.innerRef} {...provided.droppableProps}>
              {rows.map((row, index) => (
                <Draggable key={index} draggableId={`row-${index}`} index={index}>
                  {(draggableProvided) => {
                    const originalStyle = draggableProvided.draggableProps.style;

                    // Axis lock: force X = 0
                    const style = originalStyle?.transform
                      ? {
                        ...originalStyle,
                        transform: `translate(0px, ${originalStyle.transform.split(',')[1]}`
                      }
                      : originalStyle;

                    return (
                      <Box
                        ref={draggableProvided.innerRef}
                        {...draggableProvided.draggableProps}
                        style={style}  
                      >
                        <PricelistRow
                          dragHandleProps={draggableProvided.dragHandleProps} // only handle drags
                          row={row}
                          index={index}
                          companyId={companyId}
                          onAddRow={onAddRow}
                          onDeleteRow={onDeleteRow}
                          onChangeRow={onChangeRow}
                          disableDelete={rows.length < 2}
                        />
                      </Box>
                    );
                  }}
                </Draggable>
              ))}
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </DragDropContext>
    </Box>
  );
};

export default PricelistRowTable;
